import {
  Component,
  OnInit,
  Input,
  ViewChild,
  TemplateRef,
  OnDestroy
} from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { Subscription } from 'rxjs/internal/Subscription';
import {
  MatLegacyDialog,
  MatLegacyDialogRef
} from '@angular/material/legacy-dialog';
import {
  DialogStateService,
  IDialogState,
  DialogState
} from '../../../dialogs/services/dialog-state.service';
import { IAccount, IProduct } from '../../services/account-overview.service';
import { BankAccountSettingsService } from '../../services/bank-account-settings.service';
import { ApiResponse } from '../../../shared/services/api-client.service';
import { ConfigurationSettingsContextService } from '../../../shared/services/configuration-settings-context.service';
import { Item } from '@sitecore-jss/sitecore-jss/layout';
import {
  FormFields,
  FormFieldsGeneratorService
} from '../../../shared/services/form-fields-generator.service';
import { NgForm } from '@angular/forms';
import { Router, RouterEvent, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'ab-bank-account-settings',
  templateUrl: './bank-account-settings.component.html',
  styleUrls: ['./bank-account-settings.component.scss']
})
export class BankAccountSettingsComponent implements OnInit, OnDestroy {
  @Input() rendering: ComponentRendering;
  @ViewChild('bankAccountSettings') bankAccountSettings: TemplateRef<any>;
  @ViewChild('bankAccountSettingsForm') bankAccountSettingsForm: NgForm;

  public portfolio: IAccount;
  public dialogRef: MatLegacyDialogRef<any>;
  public editedProducts: IProduct[] = [];
  public tableColumns: Item;
  public formFields: FormFields;
  public allowedCharactersRegex = new RegExp(
    "^([A-Za-z0-9&@#$!*-:().,'+-])+([\\sA-Za-z0-9&@#$!*-:().,'+-])*$"
  );

  private dialogId: string;
  private dialogStateSubscription: Subscription;
  private routerSubscription: Subscription;

  constructor(
    private dialog: MatLegacyDialog,
    private dialogStateService: DialogStateService,
    private bankAccountSettingsService: BankAccountSettingsService,
    private formFieldsGeneratorService: FormFieldsGeneratorService,
    private router: Router,
    private configurationSettingsContextService: ConfigurationSettingsContextService
  ) {}

  get validationAlllowedCharacters() {
    return this.configurationSettingsContextService?.getConfigurationSettingsValidationAttributeValue(
      'ValidationAlllowedCharacters'
    );
  }

  ngOnInit() {
    this.dialogId = (<any>this.rendering.fields._id).value;
    // console.log(this.portfolio.products);
    this.routerSubscription = this.router.events
      .pipe(filter((event: RouterEvent) => event instanceof NavigationStart))
      .subscribe(() => {
        if (this.dialogRef) {
          this.dialogRef.close();
        }
      });

    this.dialogStateSubscription = this.dialogStateService
      .getDialogState()
      .subscribe((value: IDialogState) => {
        if (
          this.dialogId === value.rendaringName &&
          value.dialogState === DialogState.Open
        ) {
          this.dialogRef = this.dialog.open(this.bankAccountSettings, {
            panelClass: 'popup-dialog',
            disableClose: true
          });
          if (value.data) {
            this.portfolio = JSON.parse(value.data);
          }
          this.dialogRef.afterClosed().subscribe(() => {
            this.editedProducts = [];
          });
        }
      });

    this.tableColumns = (this.rendering.fields.items as Item[]).filter(
      (i) => i.name === 'Table'
    )[0] as Item;

    this.formFields = this.formFieldsGeneratorService.generateFormFields(
      this.rendering
    ) as FormFields;

    this.allowedCharactersRegex = new RegExp(this.validationAlllowedCharacters);
  }

  ngOnDestroy() {
    if (this.dialogStateSubscription) {
      this.dialogStateSubscription.unsubscribe();
    }

    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  addToEdit(product: IProduct) {
    if (
      this.editedProducts.length === 0 ||
      !this.editedProducts.some(
        (p) => p.accountNumber === product.accountNumber
      )
    ) {
      this.editedProducts.push(product);
    }
  }

  submit(): void {
    console.log(this.editedProducts);
    this.bankAccountSettingsService
      .saveBankAccountsSettings(this.editedProducts)
      .subscribe((response) => this.handleResponse(response));
  }

  handleResponse(response: ApiResponse) {
    if (response.callIsSuccess) {
      this.dialogRef.close();
      this.dialogStateService.closeDialogByReference(this.dialogId, true);
    }
  }
}
